import {Component, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA} from "@angular/material/snack-bar";

@Component({
  selector: 'cookie-snackbar',
  templateUrl: './cookie-snackbar.component.html',
})
export class CookieSnackbarComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) private _snackData: CookieSnackbarData) {
  }

  accept() {
    if(!this._snackData.cookieService) {
      throw Error('Не передан сервис куки');
    }

    this._snackData.cookieService.accept();
  }
}

export class CookieSnackbarData {
  cookieService: ICookieSnackbarAction;
}

export interface ICookieSnackbarAction {
  accept(): void;
}
